import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page">
      <header
        className="d-flex align-items-center text-light shadow"
        style={{
          height: "20vh",
          backgroundColor: "#003561",
        }}
      >
        <div className="container">
          <Row className="mt-5">
            <Col sm={12} md={8} lg={6}>
              <h1
                className="text-white fw-bold lh-sm"
                style={{
                  fontSize: "3rem",
                  fontFamily: "Montserrat",
                }}
              >
                Privacy Policy
              </h1>
            </Col>
          </Row>
        </div>
      </header>
      <br />
      <Container className="my-5">
        <div style={{ fontFamily: "Montserrat", color: "#003561" }}>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>Introduction</h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            Stratus Materials Inc. is
            committed to protecting the privacy of our employees and team
            members. This Privacy Policy describes how we collect, use, and
            safeguard personal information in connection with our internal SMS
            notification service ("Service").
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Information We Collect
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            In connection with our internal SMS notification Service, we may
            collect the following information:
          </p>
          <ul style={{ fontSize: "1.1rem", lineHeight: "2" }}>
            <li>Employee name</li>
            <li>Mobile phone number</li>
            <li>Employee role and department</li>
          </ul>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            How We Use Your Information
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            We use the information collected solely for the following purposes:
          </p>
          <ul style={{ fontSize: "1.1rem", lineHeight: "2" }}>
            <li>
              Sending internal company notifications, alerts, and updates via SMS
            </li>
            <li>
              Communicating important operational, safety, or administrative
              information to employees
            </li>
            <li>Maintaining and improving the reliability of the Service</li>
          </ul>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Data Sharing
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            We do <strong>not</strong> sell, rent, or share your personal
            information with third parties for marketing or advertising purposes.
            Your information may be shared only with trusted service providers
            (such as our SMS delivery platform) strictly for the purpose of
            delivering notifications.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Data Security
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            We implement appropriate technical and organizational measures to
            protect your personal information against unauthorized access,
            alteration, disclosure, or destruction.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Data Retention
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            We retain your personal information only for as long as necessary to
            fulfill the purposes described in this policy or as required by law.
            When your information is no longer needed, it will be securely
            deleted.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>Your Rights</h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            You have the right to:
          </p>
          <ul style={{ fontSize: "1.1rem", lineHeight: "2" }}>
            <li>
              Request access to the personal information we hold about you
            </li>
            <li>Request correction of any inaccurate information</li>
            <li>
              Opt out of SMS notifications at any time by replying{" "}
              <strong>STOP</strong> to any message
            </li>
          </ul>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>Contact Us</h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            If you have any questions or concerns about this Privacy Policy or
            our data practices, please contact us at:
          </p>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            <strong>Stratus Materials Inc.</strong>
            <br />
            6901 Lynn Way, Suite 320
            <br />
            Pittsburgh, PA 15208
            <br />
            Email:{" "}
            <a href="mailto:info@stratusmaterials.com">
              info@stratusmaterials.com
            </a>
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Changes to This Policy
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            We may update this Privacy Policy from time to time. Any changes will
            be communicated to affected employees. Continued use of the Service
            after changes are made constitutes acceptance of the updated policy.
          </p>
        </div>
      </Container>
    </div>
  );
}

export default PrivacyPolicy;
